import reducer from './create.reducer';
import * as action from './create.action';
import * as selector from './create.selector';
import * as constant from './create.constant';
import initialState from './create.initialState';
import saga from './create.saga';

export default {
  reducer,
  action,
  constant,
  selector,
  initialState,
  saga,
  name: constant.NAME,
};
